import {  Grid } from '@mui/material'
import HeaderComponent from 'components/HeaderComponent'
import Input from 'components/Input'
import Spinner from 'components/Spinner'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { withTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { apiRequest } from 'store/Misc/apiRequest'
import useSWR from 'swr'
function Contact({ t }) {
    const { data, isValidating } = useSWR('auth/me')
    // const [defaultState, setDefaultState] = useState({})
    const method = useForm({ mode: 'all' })
    const { register, reset, watch } = method;
    var values = data?.data
    useEffect(() => { if (values) reset({ ...values }); }, [data, reset, values])
    const [edit, setEdit] = useState(false)
    const [loading, setLoading] = useState(false)
    const submit = async (payload) => {
        const extract = Object.fromEntries(['first_name', 'last_name', 'job_position', 'phone', 'email'].map(x => [x, payload[x]]))
        if (edit) {
            if (Object.values(extract).every(x => x && x)) {
                try {
                    setLoading(true)
                    await apiRequest({
                        url: 'settings/contact-person',
                        method: 'post',
                        payload: payload
                    })
                    toast.success('Contact person updated successfully')
                } catch (error) {
                    console.log(error)
                } finally {
                    setLoading(false)
                }
                setEdit(false)
            } else {
                toast.warn('Please fill all fields')
            }
        }
        else {
            setEdit(true)
        }
    }
    return (
        <div className={'rounded-[16px] w-full p-[40px] bg-white'}>
            {!isValidating ? (<>
                {/* <header className='flex  justify-between w-full'>
                    <div className='font-[700] text-[20px]  text-[#657585] '>{t('settings.contact.header')}</div>
                    <Button variant={'contained'} color={'primary'} disabled={loading} className='rounded-[12px] bg-primary hover:bg-secondary text-[white]' onClick={() => submit(watch())}>
                        {loading ? 'Loading' : edit ? t('settings.contact.save') : 'Edit'}
                    </Button>
                </header> */}
                <HeaderComponent
                    title={t('settings.contact.header')} btnText= {loading ? 'Loading' : edit ? t('settings.contact.save') : 'Edit'} btnClick={() => submit(watch())}
                    cancelBtn={edit ? { text: 'Cancel', click: () => { setEdit(false) } } : false} />
                <FormProvider {...method}>
                    <Grid container rowSpacing={4} columnSpacing={2} >
                        <Grid item xs={12} lg={3}><Input disabled={!edit} name='first_name' label='First Name'   {...register('first_name')} /></Grid>
                        <Grid item xs={12} lg={3}><Input disabled={!edit} name='last_name' label='Last Name' {...register('last_name')} /></Grid>
                        <Grid item xs={12} lg={6}><Input disabled={!edit} name='phone ' label='Phone' {...register('phone')} /></Grid>
                        <Grid item xs={12} lg={6}><Input disabled={!edit} name='job_position' label='Posistion in this company' {...register('job_position')} /></Grid>
                        <Grid item xs={12} lg={6}><Input disabled={!edit} name='email ' label='Email address' {...register('email')} /></Grid>
                    </Grid>
                </FormProvider>
            </>) : <Spinner />}
        </div>
    )
}
export default withTranslation()(Contact)
